import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { checkRemainingTestTime } from "../../../utils/timeUtils";
import { submitTestApi } from "../../../services/saveAndNext";
import { Store } from "../../../store";

const IitSectionTimer = (props) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const intervalRef = useRef(null);
  const apiPollRef = useRef(null);

  const apiTimeRef = useRef(0);         // store API time in seconds
  const apiFetchedAtRef = useRef(0);    // store when the time was fetched
  
  const formatTime = (seconds) => {
    return (
      Math.floor(seconds / 3600) +
      " : " +
      ("0" + (Math.floor(seconds / 60) % 60)).slice(-2) +
      " : " +
      ("0" + (seconds % 60)).slice(-2)
    );
  };

  const setSessionHeaders = () => {
    const student = props?.state?.student_data;
    const test = props?.state?.test_data;
    const account = props?.state?.institute_data;
    if (student && test && account) {
      const raw = `${student.userid}:${test.test_id}:${account.account_id}:${props?.state?.session_key}`;
      return btoa(raw);
    }
    return "";
  };

  const getCurrentSectionId = () => {
    const { is_preview } = props?.state?.student_data || {};
    const { is_sec_time } = props?.state?.test_data || {};

    if (is_preview === 1 && is_sec_time === 1) {
      return props?.state?.selectedSection || `${props?.state?.subjects_data?.[0]?.subject_id}#${props?.state?.subjects_data?.[0]?.section_id}`;
    }

    const activeQ = props?.state?.ques_data?.[props?.state?.activeQuesInd];
    // console.log("👉 Calculated Section ID:", activeQ);

    return activeQ ? `${activeQ.subject_id}#${activeQ.section_id}` : null;
  };

  const handleSectionSwitch = (nextSectionId, forceSwitch = false) => {
    const isSecTime = props?.state?.test_data?.is_sec_time === 1;
    const isPreview = props?.state?.student_data?.is_preview === 1 || props?.state?.student_data?.userid === 1234567890;

    if (isSecTime && !isPreview && !forceSwitch) {
      console.warn("Manual section switch blocked during actual section-wise test.");
      return;
    }

    props.dispatch({ type: "SELECTED_SUBJECT", selectedSection: nextSectionId });

    setTimeout(() => {
      const section = props.state.subjects_data.find(
        (s) => `${s.subject_id}#${s.section_id}` === nextSectionId
      );

      if (section?.remain_time) {
        const [min, sec] = (section.remain_time || "0:0").split(":").map(v => parseInt(v) || 0);
        const sectionTimeInSec = min * 60 + sec;
        apiTimeRef.current = sectionTimeInSec;
        apiFetchedAtRef.current = Date.now();
        setRemainingSeconds(sectionTimeInSec);
      }

      const firstQIndex = props.state.ques_data.findIndex(
        (q) => `${q.subject_id}#${q.section_id}` === nextSectionId
      );

      if (firstQIndex !== -1) {
        props.dispatch({
          type: "ACTIVE_QUESTION_NUMBER",
          activeQuesInd: firstQIndex,
        });
      }
    }, 300);
  };

  const handleTimeUp = () => {
    clearInterval(intervalRef.current);
    clearInterval(apiPollRef.current);
    submitTestApi(props);
  };

  const startTimerCountdown = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;

    intervalRef.current = setInterval(() => {
      try {
        const elapsed = Math.floor((Date.now() - apiFetchedAtRef.current) / 1000);
        const syncedTime = apiTimeRef.current - elapsed;

        if (syncedTime <= 0) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;

          const currentSectionId = getCurrentSectionId();
          const currentIndex = props.allSection?.findIndex(id => id === currentSectionId);
          const nextSectionId = props.allSection?.[currentIndex + 1];

          if (
            props.state.test_data?.is_neet_test === 1 &&
            props.state.test_data?.is_sec_time === 1 &&
            nextSectionId
          ) {
            handleSectionSwitch(nextSectionId, true);
            return;
          }

          handleTimeUp();
        } else {
          setRemainingSeconds(syncedTime);
        }
      } catch (err) {
        console.error("⛔ Error in timer countdown interval:", err);
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 1000);
  };

  const updateTimerWithApi = async () => {
    const test = props.state.test_data;
    const user = props.state.student_data;
    const isPreview = user?.is_preview === 1 || user?.userid === 1234567890;
    const isSectionWise = test?.is_sec_time === 1;
// console.log("preview",props?.state?.student_data?.userid,isPreview)
    let retries = 10;
    const waitForReduxAndSubmit = () => {
      const state = Store.getState();
      let { questionstatus, answers_json, ques_data } = state;
    
      // console.log("🧠 Checking Redux state for submit...");
      // console.log("questionstatus =", questionstatus);
      // console.log("answers_json =", answers_json);
      // console.log("➡️ typeof questionstatus:", typeof questionstatus);
    
      // 🛠️ Rebuild questionstatus if undefined or invalid
      if (!Array.isArray(questionstatus)) {
        console.warn("⚠️ questionstatus is NOT an array. Rebuilding it...");
    
        try {
          if (Array.isArray(ques_data)) {
            questionstatus = ques_data.map((q) => ({
              ques_id: q.ques_id,
              status_number: 1,
            }));
            // console.log("✅ Rebuilt questionstatus from ques_data:", questionstatus);
          } else if (Array.isArray(answers_json)) {
            questionstatus = Array.from({ length: answers_json.length }, () => ({
              ques_id: 0, // fallback dummy id if ques_data is missing
              status_number: 1,
            }));
            console.warn("⚠️ ques_data not available, using dummy ques_id = 0");
          } else {
            throw new Error("Missing ques_data and answers_json");
          }
    
          // Inject into the state snapshot passed to submitTestApi
          state.questionstatus = questionstatus;
        } catch (e) {
          console.error("❌ Failed to rebuild questionstatus:", e);
        }
      }
      // console.log("📊 Final pre-submit check:");
      // console.log("👉 questionstatus =", questionstatus);
      // console.log("👉 typeof questionstatus =", typeof questionstatus);
      // console.log("👉 answers_json =", answers_json);
      // console.log("👉 typeof answers_json =", typeof answers_json);
      // console.log("👉 ques_data =", state.ques_data);
      
      // ✅ Submit only if both arrays are ready
      if (Array.isArray(questionstatus) && Array.isArray(answers_json)) {
        // console.log("✅ Redux ready. Submitting test...");
        submitTestApi({ ...props, state });
      } else if (retries > 0) {
        retries--;
        console.warn(`⏳ Redux not ready. Retrying (${10 - retries}/10)...`);
        setTimeout(waitForReduxAndSubmit, 300);
      } else {
        console.error("❌ Failed to submit test: Redux state never became ready.");
        console.error("📦 Final fallback state dump:", {
          questionstatus,
          answers_json,
        });
      }
    };
    
    
    
    

    if (isPreview) {
      if (isSectionWise) {
        const currentSectionId = getCurrentSectionId();
        const section = props.state.subjects_data.find(
          (s) => `${s.subject_id}#${s.section_id}` === currentSectionId
        );
        if (section?.section_time) {
          const timeInSec = parseInt(section.section_time) * 60;
          apiTimeRef.current = timeInSec;
          apiFetchedAtRef.current = Date.now();
          setRemainingSeconds(timeInSec);
        }
      } else {
        const testDuration = parseInt(test?.duration);
        if (!isNaN(testDuration)) {
          const timeInSec = testDuration * 60;
          apiTimeRef.current = timeInSec;
          apiFetchedAtRef.current = Date.now();
          setRemainingSeconds(timeInSec);
        }
      }
      return;
    }

    const testId = test?.test_id;
    const userId = user?.userid;
    const sessionKey = setSessionHeaders();

    try {
      const response = await checkRemainingTestTime({ testId, userId, sessionKey });

      if (response?.is_test_expired || response?.test_left_time === "0:00") {
        clearInterval(intervalRef.current);
        clearInterval(apiPollRef.current);
        submitTestApi(props);
        return;
      }

      if (
        response?.is_neet_test === 1 &&
        response?.is_sec_time === 1 &&
        Array.isArray(response.subjects)
      ) {
        const currentSectionId = getCurrentSectionId();
        const validSections = response.subjects.filter(
          (s) => typeof s.remain_time === "string" && s.remain_time.includes(":")
        );
        const allSectionsZero = validSections.every(s => s.remain_time === "0:0");

        if (validSections.length > 0 && allSectionsZero) {
          clearInterval(intervalRef.current);
          clearInterval(apiPollRef.current);
          waitForReduxAndSubmit();
          return;
        }

        const currentSection = response.subjects.find(
          (s) => `${s.subject_id}#${s.section_id}` === currentSectionId
        );

        if (currentSection?.remain_time && currentSection.remain_time !== "0:0") {
          const [min, sec] = currentSection.remain_time.split(":").map(Number);
          const timeInSec = (min || 0) * 60 + (sec || 0);
          apiTimeRef.current = timeInSec;
          apiFetchedAtRef.current = Date.now();
          setRemainingSeconds(timeInSec);
          return;
        }

        const currentIndex = response.subjects.findIndex(
          (s) => `${s.subject_id}#${s.section_id}` === currentSectionId
        );
        const nextValid = response.subjects.slice(currentIndex + 1).find(
          (s) => s.remain_time !== "0:0"
        );
        if (nextValid) {
          handleSectionSwitch(`${nextValid.subject_id}#${nextValid.section_id}`, true);
        } else {
          handleTimeUp();
        }
        return;
      }

      if (
        response?.is_sec_time === 0 &&
        response?.test_left_time
      ) {
        const [min, sec] = response.test_left_time.split(":").map(Number);
        const timeInSec = (min || 0) * 60 + (sec || 0);
        apiTimeRef.current = timeInSec;
        apiFetchedAtRef.current = Date.now();
        setRemainingSeconds(timeInSec);
        return;
      }
    } catch (err) {
      console.error("Timer error:", err);
    }
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     updateTimerWithApi();
  //   }, 1000); // delay by 1 second
  
  //   return () => clearTimeout(timer);
  // }, []);
  

  useEffect(() => {

    const user = props.state.student_data;
    if (user?.is_preview === 1 || user?.userid === 1234567890) return;
        if (props.state.timerUpdateFlag >= 1) {
      updateTimerWithApi();
    }
  }, [props.state.timerUpdateFlag]);

  useEffect(() => {

    const isSectionWise = props.state.test_data?.is_sec_time === 1;
    const selected = props.state.selectedSection;
    if (isSectionWise && selected) {
      const timeout = setTimeout(() => updateTimerWithApi(), 300);
      return () => clearTimeout(timeout);
    }
  }, [props.state.selectedSection]);

  useEffect(() => {

    const isSectionWise = props.state.test_data?.is_sec_time === 1;
  
    if (!isSectionWise) {
      const timer = setTimeout(() => {
        updateTimerWithApi();
      }, 1000); // delay 1s only for non-section-wise tests
  
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {

    const user = props.state.student_data;
    if (user?.is_preview === 1 || user?.userid === 1234567890) return;
    
    apiPollRef.current = setInterval(() => {
      try {
        updateTimerWithApi();
      } catch (err) {
        console.error("⛔ API polling error:", err);
        clearInterval(apiPollRef.current);
        apiPollRef.current = null;
      }
    }, 30000);

    return () => {
      clearInterval(apiPollRef.current);
      apiPollRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (remainingSeconds > 0) {
      startTimerCountdown();
    }
  }, [remainingSeconds]);

  return  (
    <div className="timerDiv">
      <span className="timeHeader">Time Left : </span>
      <div style={{ display: "flex" }}>
        {formatTime(remainingSeconds)
          .split(" : ")
          .map((val, idx) => (
            <React.Fragment key={idx}>
              <div className="timerun">{val}</div>
              {idx < 2 && <span style={{ margin: "0 5px" }}>:</span>}
            </React.Fragment>
          ))}
      </div>
    </div>
  ) ;
};

const mapStateToProps = (state) => ({ state });
export default connect(mapStateToProps)(IitSectionTimer);
